import React, { useEffect, useRef, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Swal from 'sweetalert2';
import "../scss/card.css"
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { generateAxiosInstanceAdminFileUpload } from '../hooks/useAuthorizedRequestForFileUpload';
import { useNavigate } from 'react-router-dom';
import VidyaUpasna from "../assets/VidyaUpasna.jpg"
import { Loader } from '../components/ModalsCommonFunctions';

const AppStoreUpdate = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosAdminFileUpload = generateAxiosInstanceAdminFileUpload()

    const initialFormState = {
        appName: "VidyaStore",
        versionCode: '',
        versionName: '',
        apkPath: '',
        isAppStore: 1
    }

    const [appData, setAppData] = useState(initialFormState);
    const [appStoreApp, setAppStoreApp] = useState();
    const inputApkFile = useRef(null);

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getApp();
    }, []);

    const getApp = () => {
        let apiUrl = '/get-apks?isAppStore=1';
        apiUrl = apiUrl.replace(/&$/, '');
        authorizedAxios && authorizedAxios.get(apiUrl)
            .then(response => {
                setAppStoreApp(response.data.result);
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            })
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setAppData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    }

    const handleUploadApkFile = async (e) => {
        e.preventDefault();
        const file = e.target.files[0];
        if (!file) {
            setAppData((prevData) => {
                return {
                    ...prevData,
                    apkPath: ''
                }
            })
            return; // Exit function if no file is selected
        }

        const fileExtension = file.name.split(".").pop().toLowerCase();
        const allowedExtensions = ["apk"];
        const body = new FormData();
        body.append("file", file);

        if (allowedExtensions.includes(fileExtension)) {
            setLoading(true);
            const apiUrl = "upload-apk-file";
            authorizedAxiosAdminFileUpload && authorizedAxiosAdminFileUpload.post(apiUrl, body)
                .then((res) => {
                    setAppData((prevData) => {
                        return {
                            ...prevData,
                            [e.target.name]: res.data.result
                        };
                    });
                    Swal.fire({
                        text: res.data.message
                    })
                })
                .catch((err) => {
                    // console.error("Error:", err);
                    Swal.fire({ text: "An error occurred while uploading the file" });
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            e.target.value = '';
            Swal.fire({ text: "Only APK files are supported" });
        }
    };

    //error
    const initialErrorState = {

    }

    const [error, setError] = useState(initialErrorState)

    const validateForm = () => {
        return Object.values(error).every((error) => error === '') && Object.values(appData).every((value) => typeof (value) == "string" ? value !== '' : value.length !== 0)
    };

    useEffect(() => {
        if (!Object.values(error).every((error) => error === '')) {
            for (const [key, value] of Object.entries(appData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }, [appData])

    const updateApp = () => {
        const apiUrl = `/add-apk`;
        if (validateForm()) {
            setLoading(true);
            authorizedAxios && authorizedAxios.post(apiUrl, appData)
                .then(response => {
                    setAppData(initialFormState)
                    inputApkFile.current.value = '';
                    setError(initialErrorState);
                    getApp();
                    Swal.fire(
                        { text: response.data.message }
                    );
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    Swal.fire(
                        { text: errorMsg }
                    );
                })
                .finally(() => {
                    setLoading(false); // End loading
                });
        } else {
            for (const [key, value] of Object.entries(appData)) {
                if (value === '' || value.length === 0) {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: 'This field is required.',
                        }
                    })
                } else {
                    setError((prevData) => {
                        return {
                            ...prevData,
                            [key]: '',
                        }
                    })
                }
            }
        }
    }

    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>App Store Update</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fas fa-sync-alt"></i>App Store Update</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="appName" className="col-form-label"><span style={{ color: "red" }}>*</span>Name of App :</label>
                                                    <input type="text" className="form-control" name="appName" disabled value={appData.appName} onChange={handleInputChange} />
                                                    {error.appName && <p style={{ color: 'red' }}>{error.appName}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="versionCode" className="col-form-label"><span style={{ color: "red" }}>*</span>Version Code :</label>
                                                    <input type="text" className="form-control" name="versionCode" value={appData.versionCode} onChange={handleInputChange} />
                                                    {error.versionCode && <p style={{ color: 'red' }}>{error.versionCode}</p>}
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="versionName " className="col-form-label"><span style={{ color: "red" }}>*</span>Version Name :</label>
                                                    <input type="text" className="form-control" name="versionName" value={appData.versionName} onChange={handleInputChange} />
                                                    {error.versionName && <p style={{ color: 'red' }}>{error.versionName}</p>}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="apkPath" className="col-form-label"><span style={{ color: "red" }}>*</span>APK Path : {/*<span style={{ color: "red" }}>only xlsx file supported </span>*/}</label>
                                                    <input required type="file" className="form-control" name="apkPath" onChange={handleUploadApkFile} ref={inputApkFile} />
                                                    {error.apkPath && <p style={{ color: 'red' }}>{error.apkPath}</p>}

                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={updateApp}>Update</button>
                                                        <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={() => { setAppData(initialFormState); inputApkFile.current.value = '' }}>Reset</button>
                                                    </div>
                                                </div>
                                            </div>

                                            {/* <div className="row">
                                                <div className="col-md-12">                                  */}
                                            <div className="row">
                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table custom_table_width">
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col">App Name </th>
                                                                        <th scope='col'>Version Code</th>
                                                                        <th scope="col">Version Name</th>
                                                                        <th scope='col'>Apk</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        appStoreApp && appStoreApp ?
                                                                            (
                                                                                <tr>
                                                                                    <td>{appStoreApp.appName}</td>
                                                                                    <td>{appStoreApp.versionCode}</td>
                                                                                    <td>{appStoreApp.versionName}</td>
                                                                                    <td>
                                                                                        <a href={appStoreApp.apkPath} download>
                                                                                            <img className='download-app' src={"https://examninja-bucket.s3.dualstack.ap-south-1.amazonaws.com/images/VidyaStore.png"} alt="APK Icon" style={{ width: '50px', height: '50px' }} title='click to download Apk' />
                                                                                        </a>
                                                                                    </td>
                                                                                </tr>
                                                                            )
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Apps Available</th>
                                                                            </tr>)
                                                                    }

                                                                </tbody>
                                                            </table>
                                                        </div>

                                                    </div>
                                                </div>

                                            </div>
                                            {/* </div>
                                            </div>
                                             */}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default AppStoreUpdate;